import { render, staticRenderFns } from "./HistogramPictures.vue?vue&type=template&id=60068e26&scoped=true&"
import script from "./HistogramPictures.vue?vue&type=script&lang=js&"
export * from "./HistogramPictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60068e26",
  null
  
)

export default component.exports